import React from 'react';
import PropTypes from 'prop-types';

import { CurrencyInputFormatter } from 'components/shared/Formatters';
import NumberInput from './NumberInput.react';

// Forward ref version of AllowNegativeCurrencyInputFormatter
const AllowNegativeCurrencyInputFormatter = React.forwardRef<any, any>(
  (props, ref) => {
    return <CurrencyInputFormatter {...props} ref={ref} allowNegative />;
  }
);

AllowNegativeCurrencyInputFormatter.displayName =
  'AllowNegativeCurrencyInputFormatter';

const CurrencyInput = ({
  InputProps = {},
  allowNegative = false,
  ...props
}) => {
  const inputComponent = allowNegative
    ? AllowNegativeCurrencyInputFormatter
    : CurrencyInputFormatter;
  const inputProps = {
    inputComponent,
    ...InputProps,
  };
  return <NumberInput {...props} InputProps={inputProps} />;
};

CurrencyInput.propTypes = {
  InputProps: PropTypes.object,
  allowNegative: PropTypes.bool,
};

export default React.memo(CurrencyInput);
